import React, { useRef } from "react";
import TrashIcon from "../../icons/trashIcon";
import EditIcon from "../../icons/editIcon";
import DragIndicatorIcon from "../../icons/dragIndicatorIcon";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import styles from "./style.module.css";

const CheckListCard = ({
  item,
  onStatusChange,
  onRemove,
  totalTask,
  showCompleted,
  onEdit,
  saveLoading,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const [isVisible, setIsVisible] = React.useState(true);
  const [display, setDisplay] = React.useState("flex");
  const [isEditing, setIsEditing] = React.useState(false);
  const [editValue, setEditValue] = React.useState(item.title);
  const inputRef = useRef(null);
  React.useEffect(() => {
    if (showCompleted.value === "completed" && !item.status) {
      setIsVisible(false);
      setTimeout(() => {
        setDisplay("none");
      }, 300);
    } else if (showCompleted.value === "incomplete" && item.status) {
      setIsVisible(false);
      setTimeout(() => {
        setDisplay("none");
      }, 300);
    } else {
      setDisplay("flex");
      setTimeout(() => {
        setIsVisible(true);
      }, 50);
    }
  }, [item, showCompleted]);

  const cardStyles = {
    ...style,
    opacity: isVisible ? 1 : 0,
    transition: "opacity 0.3s ease-out",
    display: display,
  };

  const enableEdit = () => {
    setIsEditing(true);
    // Focus the input after enabling edit mode
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  };

  const submitEdit = () => {
    setIsEditing(false);
    onEdit(item._id, editValue);
  };

  return (
    <div
      className={`${styles.checklist_card_main}`}
      ref={setNodeRef}
      style={cardStyles}
    >
      {totalTask > 1 && !item.status && (
        <div
          className={`${styles.ccm_drag} ${
            isDragging ? styles.ccm_drag_active : ""
          }`}
          {...attributes}
          {...listeners}
        >
          <DragIndicatorIcon />
        </div>
      )}
      <div
        className={`${styles.checklist_card} ${
          item.status ? styles.completed : styles.pending
        }`}
      >
        <div className={styles.cch_checkbox}>
          <label>
            <input
              type="checkbox"
              id={item._id}
              onChange={(e) => {
                onStatusChange(e.target.checked, item._id);
              }}
              defaultChecked={item.status}
              disabled={isEditing}
            />
            <div className={styles.cch_task}>
              <input
                defaultValue={editValue}
                disabled={!isEditing}
                onInput={(e) => {
                  setEditValue(e.target.value);
                }}
                ref={inputRef}
              />
            </div>
          </label>

          <div className={styles.cch_remove}>
            {isEditing ? (
              <button
                type="button"
                className={styles.cch_save}
                onClick={submitEdit}
                tabIndex={0}
              >
                Save
              </button>
            ) : (
              <button
                type="button"
                className={styles.cch_edit}
                onClick={enableEdit}
                tabIndex={0}
              >
                <EditIcon />
              </button>
            )}
            {!isEditing && (
              <button
                type="button"
                className={styles.cch_rbtn}
                onClick={() => {
                  onRemove(item._id);
                }}
                tabIndex={0}
                disabled={saveLoading}
              >
                <TrashIcon />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckListCard;
